import styled from "styled-components";
import { HeaderModalContainerProps } from "../@types/header-modal";
import MAIN_THEME from "../../../styles/themes/main-theme";

export const HeaderContainer = styled.div<HeaderModalContainerProps>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 0.75rem;
    border-radius: 0.5rem 0.5rem 0 0;

    color: ${({ headerTextColor }) => headerTextColor};
    background-color: ${({ headerColor }) => headerColor};
    border-bottom: 4px solid ${({ headerLineColor }) => headerLineColor};
`;

HeaderContainer.defaultProps = {
    headerTextColor: '#fff',
    headerColor: MAIN_THEME.colors.primaryBlue.main,
    headerLineColor: MAIN_THEME.colors.primaryPurple.main,
};

export const BodyContainer = styled.div`
    padding: 0.75rem;
    margin: 0;
    background-color: #fff;
    border-radius: 0 0 0.5rem 0.5rem;
`;

export const HeaderModalContainer = styled.div`
    display: flex;
    flex-direction: column;
`;


